import React, {useState} from "react";
import ReactTable from "react-table-v6"
import { IconButton, Tooltip } from "@material-ui/core";
import { AddCircle, ArrowForward, RemoveCircle } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import AddRelatedEquipmentDialog from "./AddRelatedEquipmentDialog"

import 'react-table-v6/react-table.css'

const RelatedEquipmentList = (props) => {
    let [openModal, setOpenModal] = useState(false)

    let history = useHistory();

    const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const addRelatedEquipment = (equipmentList) => {
        props.connectEquipmentCallback(equipmentList).then(() => {
            setOpenModal(false)
        })
    }

    const columns = [
        {
            Header: 'Location',
            accessor: 'location',
            style: {paddingTop: 15},
            Cell: p => {
                return p.value && p.value.name
            },
            show: width > 1000
        },
        {
            Header: 'Name',
            accessor: 'name',
            style: {paddingTop: 15}
        },
        {
            Header: 'System',
            accessor: 'system',
            style: {paddingTop: 15},
            Cell: p => {
                return p.value && p.value.replaceAll("_", " ")
            },
            show: width > 1000
        },
        {
            Header: 'Type',
            accessor: 'type',
            style: {paddingTop: 15},
            Cell: p => {
                let nameParts = p.value.split("_");
                let name = "";
                nameParts.forEach(p => {
                    let part = p.substring(0, 1).toUpperCase() + p.substring(1, p.length)
                    name += (name.length > 0 ? " " + part : part)
                })

                return name;
            },
        },
        {
            Header: 'Product',
            accessor: 'product',
            style: {paddingTop: 15},
            Cell: p => {
                if (p && p.value) {
                    if (p.value.company === "Unknown") {
                        return "Unknown"
                    }
                    else return p.value.company + " " + p.value.model;
                } else return null;

            },
            show: width > 1000
        },
        {
            Header: '',
            accessor: 'equipment_id',
            Cell: p => {
                return <Tooltip title="Disconnect related equipment">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"Disconnect related equipment" }
                            size={"small"}
                            onClick={() => {
                                props.disconnectEquipmentCallback(p.original)
                                }}
                          >
                            <RemoveCircle style={{color: "#FF4438"}} />
                        </IconButton>
                    </Tooltip>
            },
            width: 50,
            show: props.disconnectEquipmentCallback != null
        },
        {
            Header: '',
            accessor: 'equipment_id',
            Cell: p => {
                let link = "/equipment/" + p.value

                return <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"View equipment detail" }
                            size={"small"}
                            onClick={() => {
                                        history.push(link)
                                }}>
                            <ArrowForward />
                        </IconButton>
            },
            width: 50
        },
    ]

        return (
            <div className="equipment-list">
                 <AddRelatedEquipmentDialog equipment_id={props.equipment_id} addRelatedEquipmentCallback={addRelatedEquipment} allEquipment={props.allEquipment} open={openModal} closeCallback={() => setOpenModal(false)} />
                <div className="space-add-mode">
                { props.equipment && props.equipment.length > 0 ?
                    <Tooltip title="Connect Additional Equipment">
                        <IconButton
                                    variant="contained"
                                    color="primary"
                                    aria-label={"Connect related equipment" }

                                    onClick={() => {
                                        setOpenModal(true);
                                }}>
                                <AddCircle style={{fill: "#00b088", background: "white", transform: "scale(1.0)"}}/>
                        </IconButton>
                    </Tooltip>
                : null}
                </div>
                <div className="section-header">Related Equipment </div>
                { props.equipment && props.equipment.length > 0 ?
                    <div className="point-list-table">
                        <ReactTable key={(props.equipment && props.equipment.length) || 0}
                            data={props.equipment || []}
                            columns={columns}
                            minRows={0}
                            defaultPageSize={10}
                            showPagination={props.equipment && props.equipment.length > 10}
                        />
                    </div>
                :
                <div className="bulk_add_prompt">
                    <IconButton
                                    variant="contained"
                                    color="primary"
                                    aria-label={"Connect equipment" }

                                    onClick={() => {
                                        setOpenModal(true);
                                }}>
                            <AddCircle style={{fill: "#00b088", background: "white"}}/>
                    </IconButton>
                    There is currently no related equipment configured.
                </div>
                }


            </div>



        )
}

export default RelatedEquipmentList;
